const DATASOURCE_VIEWS = {
  "List View": 1,
  "Tile View": 2,
  "ER Diagram": 3,
  Mapping: 4,
};

const DATASOURCE_TYPES = [
  { label: "Delimited", value: "csv" },
  { label: "Parquet", value: "parquet" },
  { label: "Table", value: "Table" },
  { label: "View", value: "View" },
  { label: "Data View", value: "Data View" },
];

const TAG_COLUMN_PREFIX = "tag_";

export { DATASOURCE_VIEWS, DATASOURCE_TYPES, TAG_COLUMN_PREFIX };
